import axios from '../../../axiosConfig';

export async function getEmployees(config = {}, selectedClient) {
    return await axios.get(`/v1/employee/all/${selectedClient}`, config);
}

export async function getEmployeesSimple(clientId, config = {}) {
    return await axios.get(`/v1/employee/${clientId}/simple`, config);
}

export async function getEmployeeById(id, config = {}) {
    return await axios.get(`/v1/employee/${id}`, config);
}

export async function exportToDocx(config = {}) {
    return await axios.get(`/v1/reports/employee-equipment`, config);
}

export async function exportToPdf(config = {}) {
    return await axios.get(`/v1/reports/employee-equipment/pdf`, config);
}

export async function createEmployee(data, config = {}) {
    return await axios.post(`/v1/employee`, data, config);
}

export async function updateEmployee(data, config = {}) {
    return await axios.put(`/v1/employee`, data, config);
}

export async function deleteEmployee(employeeId, config = {}) {
    return await axios.delete(`/v1/employee/${employeeId}`, config);
}

export async function getEmployeeAssets(id, config = {}) {
    return await axios.get(`/v1/employee/${id}/assets`, config);
}

const functions = { getEmployees, getEmployeesSimple, getEmployeeById, exportToDocx, createEmployee, updateEmployee, deleteEmployee, getEmployeeAssets, exportToPdf }
export default functions
